export const getDOMContainer = (doc, cssClass) => {
	const [container] = doc.querySelectorAll(cssClass);
	return container;
};
